import _ from 'lodash';
import getHistory from 'globalHistory';

import {
  messenger as messengerCore,
  notification as notificationCore,
} from '@breezeway/brzw-react-core';

import { NAMESPACES, subscribeEvent, unsubscribeEvent } from '../../websockets';

const NAMESPACE = NAMESPACES.MESSAGING;

const EVENTS = {
  NEW_MESSAGE: 'new-message',
};

export const handleNewMessage = message => dispatch => {
  const conversationId = _.get(message, 'conversation_id', '');
  const createdAt = _.get(message, 'created_at', null);
  const messageText = _.get(message, 'message', '');
  const name = _.get(message, 'conversation.display', '');
  const isImportantMessage = _.get(message, 'conversation.important', false);
  const path = _.get(getHistory().location, 'pathname');
  const isMessengerActive = _.startsWith(path, '/messaging/conversations');
  const isImportantActive = _.startsWith(path, '/messaging/conversations/important');
  const canReceiveMessage = isMessengerActive && !(isImportantActive && !isImportantMessage);
  const shouldRedirectToImport = isImportantActive && isImportantMessage;
  const activeThreadId = isMessengerActive && _.toNumber(_.last(_.split(path, '/')));
  const isThreadActive = _.isEqual(activeThreadId, conversationId);
  const messageSentByCompany = _.get(message, 'company_sender', false);

  const showButton = {
    show_me: true,
  };

  const toastConfig = {
    autoRemove: true,
    color: '#1637f0',
    date: createdAt,
    dateToLocal: true,
    description: `<b>${name}</b>: ${messageText}`,
    footerButtons: [showButton],
    icon: 'icon-messaging-filled',
    iconStyles: {
      background: 'transparent',
      color: '#1637f0',
    },
    maxLines: 2,
    position: 'right',
    redirectionPath: shouldRedirectToImport
      ? `/messaging/conversations/important/${conversationId}`
      : `/messaging/conversations/all/${conversationId}`,
    title: 'New Message',
  };
  dispatch(messengerCore.actions.getUnreadCount());
  if (!isThreadActive && !messageSentByCompany)
    dispatch(notificationCore.actions.addToastV2(toastConfig));
  if (canReceiveMessage) dispatch(messengerCore.actions.receiveMessage(message));
  if (isThreadActive) dispatch(messengerCore.actions.getConversationMessages(conversationId));
};

export const subscribeNewMessages = () =>
  subscribeEvent(NAMESPACE, EVENTS.NEW_MESSAGE, null, handleNewMessage);

export const unsubscribeNewMessages = () => unsubscribeEvent(NAMESPACE, EVENTS.NEW_MESSAGE);
